import { API } from "config";
import request from "utilities/request";

const baseUrl = API.cortevaChain.url;

export async function deleteChatThread(
  threadId: string,
  getAccessToken: () => Promise<string>
) {
  const accessToken = await getAccessToken();
  const url = `${baseUrl}/chat/threads/${threadId}`;
  const headers = { Authorization: `Bearer ${accessToken}` };
  const options = { method: "DELETE", headers };
  await request(url, options);
}
